var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RewardChart"},[_c('div',{attrs:{"id":"chart"}}),_c('div',{staticClass:"RewardChart-footer"})])
}]

export { render, staticRenderFns }